import React from 'react'

//* utils
import * as env from '../../../../constants/environment.constants'
import { LocaleCodes, LocaleCodesSlugPrefix } from '../../../../constants/localization.constants'
import { delocalizeUrl } from '../../../../utils/functions.utils'

export const homepageTags = (dynamicSEOTags: any) => {
  dynamicSEOTags.push(
    <meta name="yandex-verification" content="f49ba49361596a26" key="yandex-tag" />,

    <meta
      name="google-site-verification"
      content="VXIXsEi0jYxHSSnd9IYLsjZg4BDODNvsjAGzz3m7crQ"
      key="yandex-tag"
    />,

    <meta
      name="google-site-verification"
      key="google-site-verification-tag1"
      content="zUwxV252NIeRj4nPxXtNm5kqtTdUhXiehgKf0L8RO2c"
    />,

    <meta
      name="google-site-verification"
      key="google-site-verification-tag2"
      content="scTtRs-w5M99W1v6htzS4TBtCghf3TZC8EIELE-Il30"
    />,

    <meta
      name="google-site-verification"
      key="google-site-verification-tag3"
      content="vA2-EverxvUVHD0_hZJ9zAV2VQjf9CPrW9sLz2D6jw4"
    />,

    <meta
      name="ahrefs-site-verification"
      key="google-site-verification-tag4"
      content="004c3735e4266c8b7c3dc74fdc5a80bfd0a409348c8243572e54bbad2888fd08"
    />,

    <meta name="msvalidate.01" content="800F6CC4D7045B6406628122C74197EE" key="msvalidate-tag" />,
    <meta name="published-date" content="November 17, 2020 2 PM" key="published-date-tag" />,
    <meta name="updated-date" key="updated-date-tag" content="April 16, 2021 6 PM" />
  )
}

export const seoTags = (
  dynamicSEOTags: any,
  seoData: any,
  isPaginated: boolean,
  pageNum: number,
  locale: string
) => {
  if (!seoData.metaDescription.includes(`undefined-${locale}`)) {
    dynamicSEOTags[1] = (
      <meta name="description" content={seoData.metaDescription} key="description-tag" />
    )

    dynamicSEOTags[2] = (
      <meta property="og:description" content={seoData.metaDescription} key="og-description-tag" />
    )

    dynamicSEOTags[3] = (
      <meta
        name="twitter:description"
        content={seoData.metaDescription}
        key="twitter-description-tag"
      />
    )
  }

  if (!seoData.titleTag.includes(`undefined-${locale}`)) {
    let titleToDisplay = seoData.titleTag

    if (isPaginated && pageNum) {
      if (pageNum > 1) {
        titleToDisplay = `Results page ${pageNum} for ${seoData.titleTag}`
      }
    }

    dynamicSEOTags[4] = <title key="title-tag">{titleToDisplay}</title>
    dynamicSEOTags[5] = <meta property="og:title" content={titleToDisplay} key="og-title-tag" />
    dynamicSEOTags[6] = (
      <meta name="twitter:title" content={titleToDisplay} key="twitter-title-tag" />
    )
  }

  if (seoData.ogtwitterImageUrl) {
    dynamicSEOTags[7] = (
      <meta property="og:image" content={`https:${seoData.ogtwitterImageUrl}`} key="og-image-tag" />
    )

    dynamicSEOTags[8] = (
      <meta
        name="twitter:image"
        content={`https:${seoData.ogtwitterImageUrl}`}
        key="twitter-image-tag"
      />
    )
  }

  if (seoData.schemaOrgJsonLdData) {
    dynamicSEOTags.push(
      <script id="uipath_schema" type="application/ld+json" key="schema-tag">
        {seoData.schemaOrgJsonLdData}
      </script>
    )
  }
}

export const prodEnvironmentTags = (dynamicSEOTags: any, seoData: any, canonicalURL: string) => {
  //* DO NOT RANDOMIZE - only add the the 5 pages we are testing in production
  //* homepage, business partners home, tech allianes home, product page -robots, & careers homepage
  //* This will remain consistant from each build
  if (
    canonicalURL === `${URL}/product/robots` ||
    canonicalURL === `${URL}/partners/buiness-partners` ||
    canonicalURL === `${URL}/partners/technology-alliances` ||
    canonicalURL === `${URL}/company/careers` ||
    canonicalURL === `${URL}`
  ) {
    dynamicSEOTags.push(
      <script key="lux-tag">
        {` LUX=(function(){var a=("undefined"!==typeof(LUX)&&"undefined"!==typeof(LUX.gaMarks)?LUX.gaMarks:[]);var d=("undefined"!==typeof(LUX)&&"undefined"!==typeof(LUX.gaMeasures)?LUX.gaMeasures:[]);var j="LUX_start";var k=window.performance;var l=("undefined"!==typeof(LUX)&&LUX.ns?LUX.ns:(Date.now?Date.now():+(new Date())));if(k&&k.timing&&k.timing.navigationStart){l=k.timing.navigationStart}function f(){if(k&&k.now){return k.now()}var o=Date.now?Date.now():+(new Date());return o-l}function b(n){if(k){if(k.mark){return k.mark(n)}else{if(k.webkitMark){return k.webkitMark(n)}}}a.push({name:n,entryType:"mark",startTime:f(),duration:0});return}function m(p,t,n){if("undefined"===typeof(t)&&h(j)){t=j}if(k){if(k.measure){if(t){if(n){return k.measure(p,t,n)}else{return k.measure(p,t)}}else{return k.measure(p)}}else{if(k.webkitMeasure){return k.webkitMeasure(p,t,n)}}}var r=0,o=f();if(t){var s=h(t);if(s){r=s.startTime}else{if(k&&k.timing&&k.timing[t]){r=k.timing[t]-k.timing.navigationStart}else{return}}}if(n){var q=h(n);if(q){o=q.startTime}else{if(k&&k.timing&&k.timing[n]){o=k.timing[n]-k.timing.navigationStart}else{return}}}d.push({name:p,entryType:"measure",startTime:r,duration:(o-r)});return}function h(n){return c(n,g())}function c(p,o){for(i=o.length-1;i>=0;i--){var n=o[i];if(p===n.name){return n}}return undefined}function g(){if(k){if(k.getEntriesByType){return k.getEntriesByType("mark")}else{if(k.webkitGetEntriesByType){return k.webkitGetEntriesByType("mark")}}}return a}return{mark:b,measure:m,gaMarks:a,gaMeasures:d}})();LUX.ns=(Date.now?Date.now():+(new Date()));LUX.ac=[];LUX.cmd=function(a){LUX.ac.push(a)};LUX.init=function(){LUX.cmd(["init"])};LUX.send=function(){LUX.cmd(["send"])};LUX.addData=function(a,b){LUX.cmd(["addData",a,b])};LUX_ae=[];window.addEventListener("error",function(a){LUX_ae.push(a)});LUX_al=[];if("function"===typeof(PerformanceObserver)&&"function"===typeof(PerformanceLongTaskTiming)){var LongTaskObserver=new PerformanceObserver(function(c){var b=c.getEntries();for(var a=0;a<b.length;a++){var d=b[a];LUX_al.push(d)}});try{LongTaskObserver.observe({type:["longtask"]})}catch(e){}};`}
      </script>
    )

    dynamicSEOTags.push(
      <script
        src="https://cdn.speedcurve.com/js/lux.js?id=819230390"
        async
        defer
        crossOrigin="anonymous"
        key="speedcurve-tag"></script>
    )
  }

  //* VWO Async script to enable SmartCode
  if (seoData.vwoScriptEnabled) {
    dynamicSEOTags.push(
      <script type="text/javascript">
        {`window._vwo_code = window._vwo_code || (function(){
          var account_id=513762,
          settings_tolerance=2000,
          library_tolerance=2500,
          use_existing_jquery=false,
          is_spa=1,
          hide_element='body',

          /* DO NOT EDIT BELOW THIS LINE */
          f=false,d=document,code={use_existing_jquery:function(){return use_existing_jquery;},library_tolerance:function(){return library_tolerance;},finish:function(){if(!f){f=true;var a=d.getElementById('_vis_opt_path_hides');if(a)a.parentNode.removeChild(a);}},finished:function(){return f;},load:function(a){var b=d.createElement('script');b.src=a;b.type='text/javascript';b.innerText;b.onerror=function(){_vwo_code.finish();};d.getElementsByTagName('head')[0].appendChild(b);},init:function(){
          window.settings_timer=setTimeout(function () {_vwo_code.finish() },settings_tolerance);var a=d.createElement('style'),b=hide_element?hide_element+'{opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important;}':'',h=d.getElementsByTagName('head')[0];a.setAttribute('id','_vis_opt_path_hides');a.setAttribute('type','text/css');if(a.styleSheet)a.styleSheet.cssText=b;else a.appendChild(d.createTextNode(b));h.appendChild(a);this.load('https://dev.visualwebsiteoptimizer.com/j.php?a='+account_id+'&u='+encodeURIComponent(d.URL)+'&f='+(+is_spa)+'&r='+Math.random());return settings_timer; }};window._vwo_settings_timer = code.init(); return code; }());`}
      </script>
    )
  }
}

export const paginatedTags = (
  dynamicSEOTags: any,
  pageNum: number,
  hrefForPage: any,
  isLastPage: boolean
) => {
  const currentPage = pageNum
  let prevHref, nextHref
  let seoLinks

  if (hrefForPage) {
    prevHref = hrefForPage(currentPage - 1)
    nextHref = hrefForPage(currentPage + 1)
  }

  if (currentPage === 1) {
    seoLinks = <link rel="next" href={nextHref} key={`hreflang-${currentPage}`} />
  } else if (isLastPage) {
    seoLinks = <link rel="prev" href={prevHref} key={`hreflang-${currentPage}`} />
  } else if (currentPage > 1) {
    seoLinks = [
      <link rel="prev" href={prevHref} />,
      <link rel="next" href={nextHref} key={`hreflang-${currentPage}`} />,
    ]
  }

  dynamicSEOTags.push(seoLinks)
}

export const availableLocaleTags = (
  dynamicSEOTags: any,
  siteSection: string,
  pageSlug: string,
  availableLocales: any,
  URL: string
) => {
  if (siteSection === 'Homepage' && !pageSlug) pageSlug = '/'
  const cnCode = LocaleCodesSlugPrefix[LocaleCodes.CHINESE.code]
  const enCode = LocaleCodesSlugPrefix[LocaleCodes.ENGLISH.code]

  if (pageSlug && availableLocales) {
    const delocalizedSlug = delocalizeUrl(pageSlug)

    for (let [lang, exists] of Object.entries(availableLocales)) {
      if (exists) {
        const langCode = LocaleCodesSlugPrefix[lang]
        const code = langCode === enCode || langCode === cnCode ? '' : '/' + langCode
        const hrefUrl = langCode === cnCode ? env.URLS.CN_PROD : env.URLS.PROD

        dynamicSEOTags.push(
          <link
            key={`hreflang-${langCode}-tag`}
            rel="alternate"
            hrefLang={`${langCode === 'cn' ? 'zh' : langCode}`}
            href={`${hrefUrl}${code}${delocalizedSlug}`}
          />
        )
      }
    }

    const xDefaultSlug = pageSlug[0] === '/' ? pageSlug.substring(1) : pageSlug

    dynamicSEOTags.push(
      <link
        key={`hreflang--tag`}
        rel="alternate"
        href={`${URL}/${xDefaultSlug}`}
        hrefLang="x-default"
      />
    )
  }
}
